<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <div class="card-group mb-0">
            <div class="card p-2">
              <div class="card-block">
                <h1>{{ $t('Admin') }}</h1>
                <p class="text-muted">
                  {{ $t('Sign In to your account') }}
                </p>
                <div v-show="!isLogged">
                  <div
                    v-if="error"
                    class="alert alert-danger"
                  >
                    {{ error }}
                  </div>
                  <form @submit.prevent="submit">
                    <div class="form-group mb-1">
                      <input
                        v-model="credentials.email"
                        type="email"
                        class="form-control"
                        placeholder="E-mail"
                        name="email"
                        required
                      >
                    </div>
                    <div class="form-group mb-1">
                      <input
                        v-model="credentials.password"
                        :placeholder="$t('Password')"
                        type="password"
                        class="form-control"
                        name="password"
                        required
                      >
                    </div>
                    <div class="row">
                      <div class="col-6">
                        <button
                          type="submit"
                          class="btn btn-primary px-2"
                          data-style="zoom-in"
                        >
                          {{ $t('Login') }}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div v-show="isLogged">
                  <p>
                    {{ $t('You are already logged in your account.') }}
                  </p>
                  <p>
                    <router-link
                      to="/dashboard"
                      class="btn btn-primary"
                    >
                      {{ $t('Go to account') }}
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserTokenService from '../services/AdminsTokensService';

export default {
  name: 'AppPageLogin',
  data() {
    return {
      credentials: {
        email: '',
        password: '',
      },
      error: '',
      isLogged: UserTokenService.getToken() !== null,
    };
  },
  methods: {
    submit() {
      this.error = '';
      const credentials = {
        email: this.credentials.email,
        password: this.credentials.password,
      };
      this.userLogin(credentials).then(() => {
        this.$router.replace('/dashboard');
      }).catch(() => {
        this.error = this.$t('Login and/or password are incorrect.');
      });
    },
  },
};
</script>
